import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Scroller = () => {

    const location = useLocation();

    useEffect(() => {
        if (location.pathname.startsWith("/industry-products")) {
            window.scrollTo(0, 0);
        } else if (location.hash) {
            const element = document.querySelector(location.hash);
            if (element) {
                element.scrollIntoView();
            }
        }
    }, [location]);
    
    return null;
};

export default Scroller;